<template>
  <div>

    <!--<b-row class="justify-content-md-center separa_revistas">
      <h3 class="text-center">REVISTAS DONDE SE HA PUBLICADO </h3>
    </b-row>
    <b-row class="align-content-md-center separa_revistas" align-self="start" v-for="(item, id) in list_revista"
           :key="item.id">
      <b-col class="revista text-center" align-self="start" cols="auto" offset-md="2" v-if="item[0]">
        <a :href="item[0]['enlace']" target=”_blank”>{{item[0]['nombre']}}</a>
      </b-col>
      <b-col class="revista text-center" align-self="center" cols="auto" offset-md="1" v-if="item[1]">
        <a :href="item[1]['enlace']" target=”_blank”>{{item[1]['nombre']}}</a>
      </b-col>
      <b-col class="revista text-center" align-self="end" cols="auto" offset-md="1" v-if="item[2]">
        <a :href="item[2]['enlace']" target=”_blank”>{{item[2]['nombre']}}</a>
      </b-col>
    </b-row>


    <br><br>
    <b-row class="justify-content-md-center separa_revistas">
      <h3 class="text-center">EVENTOS DONDE SE HA PUBLICADO </h3>
    </b-row>
    <b-row>
      <b-col offset-md="1" cols="10">
        <carousel :per-page="5" :mouse-drag="true" :autoplay="false" :autoplayTimeout="2000"
                  :autoplayHoverPause="true">
          <slide v-for="(item, id) in this.eventos"
                 :key="item.id" class="slide_item col-md-2">
            <div class="text-center">
              <p class="font-weight-bold">{{item.nombre}}</p>
            </div>
          </slide>
        </carousel>
      </b-col>
    </b-row>-->

    <b-row>
      <b-col class="col-12 col-md-5">
        <h3 class="text-center font-weight-bold">REVISTAS DONDE SE HA PUBLICADO </h3>
        <div class="col-md-10 text-center offset-1">
          <b-card-group deck>

            <b-card no-body header="">
              <b-list-group flush>
                <b-list-group-item  :href="item.enlace" target="_blank" class="investigador revista1" v-for="item in this.list_revista" :key="item.id">
                  {{item.nombre}}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </div>
      </b-col>
      <b-col offset-md="2" class="col-12 col-md-5">
        <h3 class="text-center font-weight-bold evento-titulo">EVENTOS DONDE SE HA PUBLICADO </h3>
        <div class="col-md-10 text-center offset-1">
          <b-card-group deck>
            <b-card no-body header="">
              <b-list-group flush>
                <b-list-group-item  class="investigador evento" v-for="item in events_data" :key="item.id">
                  {{item}}
                </b-list-group-item>
              </b-list-group>


            </b-card>
          </b-card-group>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {Carousel, Slide} from 'vue-carousel';

  export default {
    name: "index",
    components: {
      Carousel,
      Slide
    },
    data: function () {
      return {
        contador: 0
      }
    },
    methods: {
      ...mapActions(['getRevistas', 'getEventos', 'getTotales']),
    },
    computed: {
      ...mapGetters(['revistas', 'events_data']),
      list_revista() {
        var list = []
        var temp = []
        var count = 0
        for (var item of this.revistas) {
          temp.push(item)
          count++
          if (count == 3 || item == this.revistas[this.revistas.length - 1]) {
            list.push(temp)
            temp = []
            count = 0
          }
        }

        return Array.from(new Set(this.revistas))
      },
      list_events() {
        /*let stringSimilarity = require('string-similarity')
        console.log("similitud")
        var temp = []
        var contador = 0

        this.eventos.every((it)=>{

          if(temp.length === 0)
            temp.push(this.eventos.shift(it))
          else{
            temp.every((item)=>{
              if(stringSimilarity.compareTwoStrings(item,this.eventos[contador]) < 0.5)
                temp.push(this.eventos.pop(this.eventos[contador]))
            })
          }
          contador++
        })

        console.log(temp)*/
        return this.eventos
      }
    },
    created() {
      this.getRevistas()
      this.getEventos()
      this.getTotales()

    }
  }
</script>

<style scoped>
  h5, h3 {
    color: #1E3375;
  }

  .revista {
    background-color: rgba(213, 217, 222, 0.31);
    color: #898693;
    border-radius: 23px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-color: #B6B8BE;
    border-style: solid;
    border-width: thin;

    -webkit-box-shadow: 0px 0px 34px 0px rgba(13, 92, 157, 0.39);
    -moz-box-shadow: 0px 0px 34px 0px rgba(13, 92, 157, 0.39);
    box-shadow: 0px 0px 34px 0px rgba(13, 92, 157, 0.39);
  }

  .revista:hover {
    background-color: #D5D9DE;
    color: #1E3375;
    -ms-transform: scale(1.5); /* IE 9 */
    -webkit-transform: scale(1.5); /* Safari 3-8 */
    transform: scale(1.5);
  }

  .revista1:hover{
    background-color: #F99F47;
    border-radius: 23px;
  }

  .evento-titulo{
    color: #F99F47;
  }
  .evento:hover{
    background-color: #1E3375;
    color: white;
    border-radius: 23px;
  }

  .separa_revistas {
    margin-bottom: 25px;
  }

  .slide_item {
    background-color: #D5D9DE;
    background: #eef0f2; /* Old browsers */
    background: -moz-linear-gradient(left, #eef0f2 56%, #eef0f2 56%, #fffcfc 100%, #a0cbf0 100%, #cce4f6 100%, #eef0f2 100%, #fffcfc 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #eef0f2 56%, #eef0f2 56%, #fffcfc 100%, #a0cbf0 100%, #cce4f6 100%, #eef0f2 100%, #fffcfc 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #eef0f2 56%, #eef0f2 56%, #fffcfc 100%, #a0cbf0 100%, #cce4f6 100%, #eef0f2 100%, #fffcfc 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eef0f2', endColorstr='#fffcfc', GradientType=1);
    margin-right: 53px;
    border-radius: 23px;
  }

  .slide_item p {
    vertical-align: middle;
    margin-top: 25%;
    color: #26408C;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/index.vue